<template>
  <NuxtPage />
</template>

<script lang="ts" setup>
useHead({
  meta: [
    {
      name: "viewport",
      content:
        "width=device-width, initial-scale=1.0, viewport-fit=cover, maximum-scale=1.0, user-scalable=no, interactive-widget=resizes-content",
    },
  ],
});
</script>

<style>
html,
body {
  -webkit-user-select: none;
  -html-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -html-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
  -khtml-user-select: none;
  -khtml-user-drag: none;
  touch-action: pan-x pan-y;
}
img {
  -webkit-user-drag: none;
}

button,
a {
  touch-action: manipulation;
}

@media screen {
}
</style>
